export default __webpack_public_path__ + "static/media/1 (11).eb03faa8.png";